import {apiErrorMapper} from './apiErrorMapper';

export const apiMapper = apiErrorMapper;